import React from 'react';
import { motion } from 'motion/react';

const brandSVGVariants = {
  svgBase: {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        start: 1,
        delayChildren: 0.3,
        staggerChildren: 0.7,
      },
    },
  },
  primary: {
    hidden: { pathLength: 0, fill: 'rgba(255,255,255,0)' },
    visible: {
      pathLength: 1,
      fill: '#357bff',
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    },
  },
  secondary: {
    hidden: { pathLength: 0, fill: 'rgba(255,255,255,0)' },
    visible: {
      pathLength: 1,
      fill: '#ff7436',
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    },
  },
};

export default function AnimatedNexlaMark({ shrinkFactor = 1 }) {
  const width = 106 / shrinkFactor;
  const height = 51 / shrinkFactor;

  return (
    <div style={{ display: 'flex' }}>
      <motion.svg
        width={width}
        height={height}
        viewBox="0 -27 106 106"
        xmlns="http://www.w3.org/2000/svg"
        variants={brandSVGVariants.svgBase}
        initial="hidden"
        animate="visible"
      >
        <motion.path
          d="M8.935 45l27.903-31.3268c2.143-2.4059 6.2652-2.5903 8.6815-.3592l17.354 16.0206L71 20.7526 53.6464 4.7326c-7.306-6.746-19.154-6.216-25.7434 1.1818L0 37.2411 8.935 45Z"
          stroke="#357bff"
          variants={brandSVGVariants.primary}
        />
        <motion.path
          d="M97.065 6L69.1623 37.3264c-2.1426 2.4055-6.2685 2.5906-8.6815.3625L43.1272 21.6656 35 30.2468 52.3535 46.27c7.3036 6.7438 19.155 6.2122 25.7437-1.1848L106 13.759 97.065 6Z"
          stroke="#ff7436"
          variants={brandSVGVariants.secondary}
        />
      </motion.svg>
    </div>
  );
}
